import { render, staticRenderFns } from "./KeyStats.vue?vue&type=template&id=7fdbb1d8&scoped=true&"
import script from "./KeyStats.vue?vue&type=script&lang=js&"
export * from "./KeyStats.vue?vue&type=script&lang=js&"
import style0 from "./KeyStats.vue?vue&type=style&index=0&id=7fdbb1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdbb1d8",
  null
  
)

export default component.exports